// extracted by mini-css-extract-plugin
module.exports = {"Menu":"AlignArrangeMenu_Menu__3KlCP","MenuWrapper":"AlignArrangeMenu_MenuWrapper__2P8nw"};